import LandingPage from "@/pages/Landing";
import VerifyPage from "@/components/auth/VerifyPage";

export default [
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage,
    props: { mode: "login" }
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LandingPage,
    props: { mode: "login" }
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: LandingPage,
    props: { mode: "register" }
  },
  {
    path: "/forgotPassword",
    name: "ForgotPasswordPage",
    component: LandingPage,
    props: { mode: "forgotPassword" }
  },
  {
    path: "/resetmypassword/:uid",
    name: "ResetPasswordPage",
    component: LandingPage,
    props: { mode: "resetPassword" }
  },
  {
    path: "/verifyEmail/:verificationKey",
    name: "VerifyPage",
    component: VerifyPage
  },
]